import { api, toQuery } from "./client";
import type { LogEntry, PaginatedTasks, Task, TaskSummary } from "../lib/types";

export function listTasks(params: { page?: number; per_page?: number; status?: string }) {
  return api<PaginatedTasks>(`/api/v1/tasks${toQuery(params)}`);
}

export function getTaskSummary() {
  return api<{ summary: TaskSummary }>("/api/v1/tasks/summary");
}

export function getTask(id: string) {
  return api<Task>(`/api/v1/task/${encodeURIComponent(id)}`);
}

export function listTaskLogs(id: string) {
  return api<{ logs: LogEntry[]; total: number }>(`/api/v1/task/${encodeURIComponent(id)}/logs?per_page=200`);
}

export function retryTask(id: string) {
  return api<{ message: string; task: Task }>(`/api/v1/task/${encodeURIComponent(id)}/retry`, { method: "POST" });
}

export function resetTask(id: string) {
  return api<{ message: string; task: Task }>(`/api/v1/task/${encodeURIComponent(id)}/reset-to-queued`, { method: "POST" });
}

export function markTaskFailed(id: string) {
  return api<{ message: string; task: Task }>(`/api/v1/task/${encodeURIComponent(id)}/mark-failed`, { method: "POST" });
}
